module.exports = __webpack_public_path__ + "img/personage4.256e6281.png";